import { StateService } from './../../../../shared/services/state.service';
import { IPaged } from '../../../../_models/common/IPaged';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-state-list',
  templateUrl: './state-list.component.html'
})
export class StateListComponent implements OnInit {
  private readonly PAGE_SIZE = 10;

  queryResult: IPaged = {
    pageNumber: 0,
    items: [],
    totalRows: 0,
    pageSize: this.PAGE_SIZE
  };

  query: any = {
    page: 1,
    pageSize: this.PAGE_SIZE,
    sort: 'UpdatedAt',
    sortDir: 'Descending',
    regionId: ''
  };

  columns = [
    { title: 'Sr.No.', key: 'Id', isSortable: true },
    { title: 'Name', key: 'Name', isSortable: true },
    {}
  ];

  constructor(private router: Router,
    private route: ActivatedRoute,
    private service: StateService) {
  }

  ngOnInit() {
    this.route.queryParams
      .subscribe(params => {
        this.query.page = isNaN(params.page) ? 1 : params.page;
        this.query.sort = params.sort;
        this.query.sortDir = params.sortDir;
        this.populateStates();
      });
  }

  private populateStates() {
    this.service.getAll(this.query)
      .subscribe((response: IPaged) => {
        if (response) {
          this.queryResult = response;
        }
      });
  }

  sortBy(columnName) {
    this.query.page = 1;
    if (this.query.sort === columnName) {
      this.query.sortDir = (this.query.sortDir == "Descending" ? "Ascending" : "Descending");
    } else {
      this.query.sort = columnName;
      this.query.sortDir = "Descending";
    }

    this.router.navigate(['/admin/states'], {
      queryParams: this.query
    });
  }

}
